import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StoreService {

  constructor() { }

  get<T>(key: string): T {
    let value: string;
    try {
      value = localStorage.getItem(key);
    } catch (error) {
      console.warn(`Unable to read localStorage value for ${key}.`, error);
      return null;
    }

    if (!value) {
      return null;
    }

    try {
      return JSON.parse(value) as T;
    } catch (error) {
      console.warn(`Invalid localStorage value for ${key}. Removing it.`, error);
      this.remove(key);
      return null;
    }
  }

  set(key: string, value: any) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.warn(`Unable to save localStorage value for ${key}.`, error);
    }
  }

  getArray<T>(key: string): T[] {
    const value = this.get<unknown>(key);
    if (value === null) {
      return [];
    }
    if (Array.isArray(value)) {
      return value as T[];
    }

    console.warn(`Invalid localStorage array value for ${key}. Removing it.`);
    this.remove(key);
    return [];
  }

  remove(key: string) {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.warn(`Unable to remove localStorage value for ${key}.`, error);
    }
  }

  clear() {
    try {
      localStorage.clear();
    } catch (error) {
      console.warn('Unable to clear localStorage.', error);
    }
  }
}

export interface StoreChapter {
  chapterid: string,
  chapterComposition: string
}
